import React, { FC, PropsWithChildren, ReactElement } from 'react'

import './Page.scss'

export interface PageProps {
    className?: string;
}

const Page: FC<PropsWithChildren<PageProps>> = ({ className = '', children }): ReactElement => (
    <main className={`page ${className}`}>
        {children}
    </main>
)

export default Page
